import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from 'axios';

const baseUrl = process.env.REACT_APP_BASE_URL;

//action

export const createMatOutwardEntry = createAsyncThunk('createMatOutwardEntry', async (postData) => {

    try {
        const response = await axios.post(`${baseUrl}?apicall=insertMaterialOutWard`, postData);
        return response.data;
    } catch (error) {
        throw error;
    }
});

export const updateMatOutwardEntry = createAsyncThunk('updateMatOutwardEntry', async (postData) => {
    try {
        const response = await axios.post(`${baseUrl}?apicall=updateMaterialOutward`, postData);
        return response.data;
    } catch (error) {
        throw error;
    }
});

export const fetchMatOutwardData = createAsyncThunk('fetchMatOutwardData', async () => {
    try {
        const response = await axios.get(`${baseUrl}?apicall=getMaterialOutwardList`);
        return response.data;
    } catch (error) {
        throw error;
    }
});

export const fetchSingleMatOutward = createAsyncThunk('fetchSingleMatOutward', async (id) => {
    try {
        const response = await axios.get(`${baseUrl}?apicall=getMaterialOutwardList&matOutId=${id}`);
        return response.data;
    } catch (error) {
        throw error;
    }
});


export const deleteSingleMatOutward = createAsyncThunk('deleteSingleMatOutward', async (id) => {
    try {
        const response = await axios.delete(`${baseUrl}?apicall=deleteMaterialOutward&matOutId=${id}`);
        return response.data;
    } catch (error) {
        throw error;
    }
});

export const fetchMatOutwardStkValue = createAsyncThunk('fetchMatOutwardStkValue', async (id) => {
    try {
        const response = await axios.get(`${baseUrl}?apicall=getMaterialOutwardList&matId=${id}`);
        return response.data;
    } catch (error) {
        throw error;
    }
});


const matOutwardSlice = createSlice({
    name: 'MatOutwardData',
    initialState: {
        isLoading: false,
        matOutward: null,
        deleteMatOutward: null,
        singleMatOutward: null,
        stkValue: null,
        isError: false
    },
    extraReducers: (builder) => {
        builder.addCase(fetchMatOutwardData.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(fetchMatOutwardData.fulfilled, (state, action) => {
            state.isLoading = false;
            state.matOutward = action.payload;
        });
        builder.addCase(fetchMatOutwardData.rejected, (state, action) => {
            console.log('Error', action.error.message);
            state.isError = true;
        });

        builder.addCase(deleteSingleMatOutward.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(deleteSingleMatOutward.fulfilled, (state, action) => {
            state.isLoading = false;
            state.deleteMatOutward = action.payload;
        });
        builder.addCase(deleteSingleMatOutward.rejected, (state, action) => {
            console.log('Error', action.error.message);
            state.isError = true;
        });


        builder.addCase(fetchSingleMatOutward.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(fetchSingleMatOutward.fulfilled, (state, action) => {
            state.isLoading = false;
            state.singleMatOutward = action.payload;
        });
        builder.addCase(fetchSingleMatOutward.rejected, (state, action) => {
            console.log('Error', action.error.message);
            state.isError = true;
        });

        builder.addCase(fetchMatOutwardStkValue.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(fetchMatOutwardStkValue.fulfilled, (state, action) => {
            state.isLoading = false;
            state.stkValue = action.payload;
        });
        builder.addCase(fetchMatOutwardStkValue.rejected, (state, action) => {
            console.log('Error', action.error.message);
            state.isError = true;
        });


    }
});

export default matOutwardSlice.reducer;
